import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { ArcherElement } from 'react-archer'

import useStyles from '../../styles'

import { ConnectionPoints } from '../'

const DataElement = ({ element }) => {
  const classes = useStyles()

  return (
    <ArcherElement
      key={element.id}
      id={element.id}
      relations={element.relations}
    >
      <Box
        className={classes.dataObject}
        style={{
          borderColor: element.color || 'black',
          backgroundColor: 'white',
        }}
      >
        <Box className={classes.dataObjectFold} />
        <Box
          className={classes.dataObjectFoldEdge}
          style={{
            borderLeftColor: element.color || 'black',
            borderBottomColor: element.color || 'black',
          }}
        />
        <Typography
          variant="body1"
          style={{
            color: element.textColor || 'black',
            fontWeight: 'bold',
            wordBreak: 'break-word',
            hyphens: 'auto',
          }}
        >
          {element.name}
        </Typography>
        <ConnectionPoints connectionTypes={element.connectionTypes} />
      </Box>
    </ArcherElement>
  )
}

export default DataElement
